// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tiptap p.is-editor-empty:first-child:before{color:#adb5bd;content:attr(data-placeholder);float:right;height:0;pointer-events:none}.tiptap span[data-type=mention]{--tw-text-opacity:1;color:#1f50ab}@supports (color:rgb(0 0 0/0)) and (top:var(--f )){.tiptap span[data-type=mention]{color:rgb(31 80 171/var(--tw-text-opacity))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
